import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import { trackEvent } from '../lib/analytics';
import { useMixpanel } from '../lib/mixpanel';
import {
  type EnrichmentTriggerResponse,
  type TriggerEnrichmentPayload,
  workflowsAPI,
} from '../lib/workflowsApi';

export const useTriggerWorkflow = (): UseMutationResult<
  EnrichmentTriggerResponse,
  Error,
  TriggerEnrichmentPayload,
  unknown
> => {
  const mp = useMixpanel();

  return useMutation({
    mutationFn: async (payload: TriggerEnrichmentPayload) => {
      const response = await workflowsAPI.triggerEnrichment(payload);
      return response.data;
    },
    onSuccess: () => {
      trackEvent(mp, 'workflow.triggered');
    },
  });
};
